import { useMemo } from "react";
import { useSelector } from "react-redux";
import { computeFulfillment } from "utils/computeFulfillment";

export const useCheckoutFulfillment = () => {
  const checkoutState = useSelector(({ checkout }) => checkout);
  return useMemo(
    () => computeFulfillment(checkoutState),
    [checkoutState.checkoutTimeSlot, checkoutState.isFollowedEbtPayment, checkoutState.savePlaceOrder]
  );
};
